'use strict';

var Svg = {};

// tempRGBcolor converts a temperature value to a rgb-value between 0 and 255
Svg.temperatureToRGBcolor = function (temp, tMin, tMax) {
    var scale = 255 / (tMax - tMin);
    temp = (temp - tMin) * scale;
    // shorten the range for which the color is neither small nor large
    var violetCompression = 4;
    if (Math.abs(temp - 128) <= 10) {
        temp = (temp - 128) * violetCompression + temp;
    }

    // defines the point from which on the color changes faster to the end state
    var compressionRange = 10;
    if (temp < 128 - compressionRange) {
        temp = temp / 2 + (128 - compressionRange * violetCompression) - (128 - compressionRange) / 2;
    }

    if (temp > 128 + compressionRange) {
        temp = temp + (128 + compressionRange * violetCompression) - (128 + compressionRange);
    }

    // make sure, the temp stays in the domain 0 to 255;
    if (temp < 0) {
        temp = 0;
    }
    if (temp > 254) {
        temp = 255;
    }
    temp = Math.round(temp);
    return 'rgb(' + (255 - temp) + ',0,' + temp + ')';
};

// draws a path with the given params into an existing svg tag.
Svg.drawPath = function (svg, path, attr) {
    attr = attr || {};
    attr.strokeWidth = attr.strokeWidth || '1';
    attr.classes = attr.classes || 'stroke-custom fill-none';

    //Create a path in SVG's namespace and modify its attributes
    var newElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    newElement.setAttribute('d', path); // Set path's data
    newElement.style.strokeWidth = attr.strokeWidth; // Set line width
    newElement.setAttribute('class', attr.classes); // any set of classes can be set here. ATTENTION!
    // one of the clases should set the stroke attribute, otherwise
    // you won't see anything (can be used to hide path for debugging
    // purpose)
    svg.appendChild(newElement);
};

Svg.createSVGElement = function (type, attributes) {
    //Create an element in SVG's namespace
    var element = document.createElementNS('http://www.w3.org/2000/svg', type);
    for (var key in attributes) {
        if (attributes.hasOwnProperty(key)) {
            element.setAttribute(key, attributes[key]);
        }
    }
    return element;
};

// puts 'text' at the position (x,x) inside the svg-element with the (optional) svgAttributes. Minimal example:
// Svg.drawText(mySVGTagElement, 'My awsome Text', {x:-30, y:10})
// And more complete:
// Svg.drawText(mySVGTagElement, 'My awsome Text', {x:-30, y:10, 'font-size': '30'}, {stroke:blue, strokeWidth:20, fill:'red'})
Svg.drawText = function (svg, text, attributes, style) {
    var newElement = Svg.createSVGElement('text', attributes);
    // assigning svg-attributes
    $.each(style || {}, function (name, value) {
        newElement.style.setProperty(name, value);
    });
    $(newElement).text(text);
    svg.appendChild(newElement);
};

// draws a rectangle into the provided svg tag. Coordinates are relative to the viewport (svg internal coordinates)
// example: drawRectangle(mySvgTag, {x:0, y:-10, width:300, height: 50});
Svg.drawRectangle = function (svg, attributes) {
    var newElement = Svg.createSVGElement('rect', attributes);
    svg.appendChild(newElement);
    return newElement;
};

// adds a class to a svg-element (jquery does not work on svg elements)
Svg.addClass = function ($elements, cl) {
    _.each($elements, function (element) {
        if (element != undefined) {
            var classes = element.getAttribute('class').split(' ');
            classes = _.union(classes, cl.split(' '));
            element.setAttribute('class', classes.join(' '));
        }
    });
};

// removes a class from a svg-element (jquery does not work on svg elements)
Svg.removeClass = function ($elements, cl) {
    _.each($elements, function (element) {
        var classes = _.unique(element.getAttribute('class').split(' '));
        var newClasses = _.difference(classes, cl.split(' '));
        element.setAttribute('class', newClasses.join(' '));
    });
};

// --------- coordinate transformations --------
// inverts an axis in such a way, that min and max are swapted and the axis' direction is in inverted
Svg.invertAxis = function (x, min, max) {
    return min + max - x;
};

// converts the given screen coordinates to svg-coordinates, e.g. the coordiantes in the viewBox
Svg.getSVGCoordinatesFromScreen = function (svgElement, x, y) {
    var pt = svgElement.createSVGPoint();
    pt.x = x;
    pt.y = y;
    return pt.matrixTransform(svgElement.getScreenCTM().inverse());
};

// positionElement fakes relativ positioning. It returns the absolute coordinates needed,
// to position an element relativ to another one (its container).
//
// - containerBBox is the bounding box of the container
// - elementBBox is the bounding box of the element
// - anchor is a position inside the element's bounding box, which is referenced for the positioning
// - targetPosition is a position inside the container.
//
// Example: positionElement(container, element, lt, c) moves the center of elemnte to the top
// left corner of the container.
// container   element_
// |lt t rt|   |lt t rt|
// |l  c  r|   |l  c  r|
// |lb b rb|   |lb b rb|
// _________   _________
Svg.positionElement = function (containerBBox, elementBBox, targetPosition, anchor) {
    function getPositionOnBBox(bbox, targetPos, invert) {
        if (invert) {
            bbox.width = -bbox.width;
            bbox.height = -bbox.height;
        }
        // get starting point (=c)
        var coord = { x: bbox.x + bbox.width / 2, y: bbox.y + bbox.height / 2 };
        if (typeof targetPos != 'string' || targetPos.length > 2 || targetPos.length < 1) {
            targetPos = 'c';
        }
        targetPos = targetPos.toLowerCase();
        if (targetPos.includes('l')) {
            coord.x -= bbox.width / 2;
        }
        if (targetPos.includes('r')) {
            coord.x += bbox.width / 2;
        }
        if (targetPos.includes('t')) {
            coord.y -= bbox.height / 2;
        }
        if (targetPos.includes('b')) {
            coord.y += bbox.height / 2;
        }
        return coord;
    }

    var startPosition = getPositionOnBBox(containerBBox, targetPosition);
    elementBBox.x = startPosition.x;
    elementBBox.y = startPosition.y;
    return getPositionOnBBox(elementBBox, anchor, true);
};

// returns the svg coordinates for all elements of the y-axis
// - ticks: labels for the main ticks, starting from bottom to top
// - position: position of the complete axis in the container SVG
Svg.getYAxisConfig = function (ticks, position) {
    // ______ main tick        T
    // __     sub sub tick     |
    // __                      |
    // __                      |
    // ____   sub tick     scale height
    // __                      |
    // __                      |
    // __                      |
    // ______                  _

    // the length of the axis (depends on the number of main ticks)
    var maxLength = 30 * (ticks.length - 1);
    var config = {
        position: { x: position.x, y: position.y },
        ticks: [],
        subTicks: [],
        subSubTicks: [],
        scaleHeight: maxLength,
    };
    _.each(
        ticks,
        function (t, index) {
            config.ticks.push({
                text: t,
                textPosition: 9 + maxLength - 30 * index, // y-axis is inverted in SVG -> invert order of tick labels
                position: 5 + 30 * index,
            });
            config.subTicks.push(20 + 30 * index);
        },
        this
    );
    // there is always one subtick less than ticks -> remove last subtick
    config.subTicks.splice(ticks.length - 1, 1);
    for (var i = 0; i < 10 * (ticks.length - 1); i++) {
        config.subSubTicks.push(2 + 3 * (i + 1));
    }
    return config;
};
module.exports = Svg;
